module.exports = __webpack_public_path__ + "public/img/tamcm.fe1dfd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/tamcm.png
// module id = nsKJ
// module chunks = 1